import React from 'react';

import {
  Box,
  Button,
  FormControl,
  Grid,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';

import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import StepperSubHeader from '../../../../components/Header/StepperSubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import { NumberFormatCustom } from '../../../../components/NumberFormartCustom/NumberFormatCustom.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import useCancelPolicy from './hooks';

const CancelPolicy = () => {
  const {
    loading,
    open,
    setOpen,
    tramitNumber,
    handleWorkflowSuccess,
    classes,
    errors,
    handleChange,
    values,
    handleSubmit,
    setConfirm,
    error,
    setError,
    inProcess,
    setInProcess,
    handleFailure,
    confirm,
    cancelReasonsList,
    handleDiscardRequest,
    history,
    handleConfirm,
  } = useCancelPolicy();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando'}></Loader>
      </Box>

      <StepperSubHeader goBack={() => history.goBack()}></StepperSubHeader>

      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Typography variant="h6" style={{ marginBottom: '15px' }}>
              Número de trámite{' '}
              <span style={{ color: '#2A54AF' }}>{tramitNumber}</span>
            </Typography>
            <Typography style={{ marginBottom: '10px' }}>
              Según tu ciclo de facturación se puede emitir una última factura.
            </Typography>
            <Typography>
              Dentro de las 72hs, si no logramos contactarte, la baja se
              procesará de todos modos según tu fecha de solicitud.
            </Typography>
          </Box>
        }
        actions={
          <Grid container>
            <Grid item xs={12} sm={12}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleWorkflowSuccess}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SharedDialog
        open={inProcess}
        onClose={() => setInProcess(false)}
        content={
          <Box>
            <Typography variant="h6" style={{ marginBottom: '15px' }}>
              Tu solicitud ya está en trámite
            </Typography>
            <Typography style={{ marginBottom: '10px' }}>
              Ya registramos tu pedido.
            </Typography>
            <Typography>
              Dentro de las 72hs siguientes, si no logramos contactarte, la baja
              se procesará de todos modos.
            </Typography>
          </Box>
        }
        actions={
          <Grid container>
            <Grid item xs={12} sm={12}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleWorkflowSuccess}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SharedDialog
        open={error}
        onClose={() => setError(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6" style={{ marginBottom: '15px' }}>
                Ha ocurrido un error.
              </Typography>
              <Typography>
                ¡Lo sentimos! Esta solicitud no puede procesarse. Por favor
                reintentá más tarde o comunicate con nosotros por Whatsapp para
                registrar tu solicitud.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleFailure}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" fullWidth color="secondary">
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      {confirm ? (
        <>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={10}>
              <Typography
                variant="h2"
                color="primary"
                style={{
                  fontWeight: 'bold',
                  fontSize: '22px',
                  marginTop: '25px',
                  marginBottom: '20px',
                }}
              >
                Solicitud de cancelación
              </Typography>
            </Grid>

            <Grid item xs={10}>
              <Typography style={{ marginBottom: '30px' }}>
                Para avanzar, te pedimos que verifiques tus datos personales y
                nos ayudes a mejorar nuestro servicio, indicándonos el motivo de
                baja.
              </Typography>
            </Grid>

            <Grid container justify="center" alignItems="center">
              <Grid item xs={10}>
                <Box mr={2} my={2}>
                  <Typography variant="subtitle2" className={classes.label}>
                    Email *
                  </Typography>
                  <TextField
                    type="email"
                    size="small"
                    onChange={handleChange}
                    fullWidth={true}
                    error={Boolean(errors['email'])}
                    helperText={errors['email']}
                    name="email"
                    id="email"
                    placeholder="email@autocompletado.com"
                    variant="outlined"
                    value={values.email}
                  />
                </Box>
              </Grid>

              <Grid item xs={10}>
                <Box mr={2} my={2}>
                  <Typography variant="subtitle2" className={classes.label}>
                    Teléfono *
                  </Typography>
                  <TextField
                    InputProps={{
                      inputComponent: NumberFormatCustom as any,
                    }}
                    size="small"
                    onChange={handleChange}
                    fullWidth={true}
                    error={Boolean(errors['phone'])}
                    helperText={errors['phone']}
                    name="phone"
                    id="phone"
                    type="number"
                    placeholder="(Prefijo + Número / Sin “0” y sin “15”)"
                    variant="outlined"
                    value={values.phone}
                  />
                </Box>
              </Grid>

              <Grid item xs={10}>
                <Box mr={2} my={2}>
                  <Typography variant="subtitle2" className={classes.label}>
                    Motivo de baja *
                  </Typography>
                  <FormControl
                    fullWidth
                    size="small"
                    variant="outlined"
                    error={Boolean(errors['reason_id'])}
                  >
                    <Select
                      fullWidth={true}
                      variant="outlined"
                      value={values.reason_id}
                      id="reason_id"
                      name="reason_id"
                      onChange={handleChange}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      defaultValue=""
                    >
                      <MenuItem value={''} disabled>
                        Seleccione una opción
                      </MenuItem>
                      {cancelReasonsList &&
                        cancelReasonsList.map((reason: any) => (
                          <MenuItem key={reason.id} value={reason.id}>
                            {reason.reason}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid container justify="center" alignItems="center">
          <Grid item xs={10}>
            <Grid item xs={10}>
              <Typography style={{ marginTop: 40, marginBottom: 20 }}>
                Lamentamos que tomes esta decisión, si tenés algún problema
                quizás podemos solucionarlo desde nuestros canales de atención.
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography style={{ marginBottom: 20 }}>
                Si aún así quieres cancelar tu póliza, presioná continuar.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {confirm ? (
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} sm={5}>
            <Box m={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                disabled={!!Object.keys(errors).length || !values.reason_id}
              >
                Enviar solicitud
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} sm={5}>
            <Box m={2}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handleDiscardRequest}
              >
                Descartar solicitud
              </Button>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} sm={5}>
            <Box m={2}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={() => handleConfirm()}
              >
                Continuar
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} sm={5}>
            <Box
              m={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Link
                href={appConfig?.WHATSAPP_LINK}
                rel="noopener"
                target="_blank"
              >
                <Button variant="text" fullWidth color="secondary">
                  <img
                    src={WhatsappSrc}
                    alt="Whatsapp"
                    style={{ marginRight: '15px' }}
                  />
                  <Typography display="inline">
                    Comunicarme vía Whatsapp
                  </Typography>
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default CancelPolicy;
